import { backendApiUrl } from '../config/api-url';
import { axiosClient } from '../config/axios-client';
import commonStore from './CommonStore';
import localStorageStore from './LocalStorageStore';

const BASE_API_PATH = '/user-activity';

class UserActivityStore {
  public updateBackgroundStatus = async (
    inBackground: boolean,
  ): Promise<void> => {
    await axiosClient.post(`${BASE_API_PATH}/background`, {
      inBackground,
    });
  };

  public updateOnlineStatus = async (): Promise<void> => {
    await axiosClient.post(`${BASE_API_PATH}/online`, {
      online: true,
    });
  };

  public updateOfflineStatus = (token: string): void => {
    navigator.sendBeacon(
      `${backendApiUrl}${BASE_API_PATH}/offline?token=${token}`,
    );
  };

  public onCloseTab = (): void => {
    const token = localStorageStore.getToken();
    localStorageStore.removeActiveTab(commonStore.activeTab);
    if (localStorageStore.checkActiveTabs() === 0) {
      this.updateOfflineStatus(token);
    }
  };
}

const userActivityStore = new UserActivityStore();
export default userActivityStore;
